<template>
    <div>
        <div class="name"> 
            <span>{{specs[name].mobileName || specs[name].name}}</span>
            <Tooltip v-if="specs[name].tooltip" class="spec-tooltip" :content="specs[name].tooltip" />
        </div>
        <div class="spec"> 
            <span v-html="body"></span>
            <Tooltip v-if="tooltip" class="spec-tooltip" :content="tooltip" />
        </div>
    </div>
</template>
  
<script>
import Tooltip from './Tooltip.vue';
import specs from '../constants/specs';

export default {
    name: "Spec",
    components: { Tooltip },
    props: ["name", "content"],
    data() {
        const [body, tooltip] = this.content.split('|');

        return {
            specs,
            body,
            tooltip
        }
    }
};
</script>
  
<style lang="scss">
    
.name, .spec {
    display: flex;
    align-items: center;
    justify-content: center;
}

.name {
    display: none;
    background-color: rgba(250, 250, 250, 1);
}

.spec-tooltip {
    margin-left: 5px;
}

@media (max-width: $bp-mobile) {
    .name {
        display: flex;
    }

    .spec {
        background-color: #FFF;
        color: $color-primary;
    }
}
</style>
  